import React from 'react';

const About: React.FC = () => {
  return (
    <section id="sobre" className="py-24 px-6 bg-[#f8f9fb]">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-3xl md:text-5xl font-serif font-bold text-brand-dark mb-8">Sobre a Dr. Alvará</h2>
        <div className="space-y-6 text-lg text-gray-500 leading-relaxed">
          <p>
            Somos especialistas em alvarás, licenças e segurança documental contínua, garantindo que seu negócio opere com tranquilidade.
          </p>
        </div>
      </div>
    </section>
  );
};

export default About;
